// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p.description img {\n    max-width: 100%;\n    height: auto !important;\n}\n\n", "",{"version":3,"sources":["webpack://./src/components/Introduction/Introduction.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,uBAAuB;AAC3B","sourcesContent":["p.description img {\n    max-width: 100%;\n    height: auto !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
